/* eslint-disable react/no-danger,react/no-unescaped-entities,jsx-a11y/href-no-hash,react/self-closing-comp,react/prefer-stateless-function,react/forbid-prop-types */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from "apollo-boost";
import {Query} from "react-apollo";
import Article from "./Article";

const GET_PAGE_INNER = `
... on NodeArticle {
  entityUrl {
    path
    routed
  }
  entityMetatags {
    key
    value
  }
  fontOverride: fieldFontOverride
  id: entityId
  cssId: fieldCssId
  title: entityLabel
  content: body {
      processed
      summaryProcessed
  }
  authors: fieldAuthors
  hideImageFromArticle: fieldHideImageFromArticle
  supportingImage: fieldSupportingImageMedia {
      entity {
        ... on MediaImage {
          fieldMediaImage {
              url
              alt
          }
        }
      }
  }
  date: fieldItemDate {
      value
  },
  link: fieldItemLink {
      title
      uri
  }
  ctas: fieldArticleCtas {
      targetRevisionId
  }
  entityPublished
  fieldArticleComponents {
    targetRevisionId
  }
  fieldSubtitle
}
`;

const GET_PAGE = gql`
    query nodeById($id: String!) {
        nodeById(id: $id) {
            ${GET_PAGE_INNER}
        }
    }
`;

const GET_REVISION = gql`
    query nodeRevisionById($id: String!) {
        nodeById:nodeRevisionById(id: $id) {
            ${GET_PAGE_INNER}
        }
    }
`;

class ArticleRevision extends Component {

    static propTypes = {
        revisionId: PropTypes.string.isRequired,
        isRevision: PropTypes.bool
    };

    static defaultProps = {
        isRevision: false
    };

    render() {
        const {revisionId, isRevision} = this.props;

        return (
            <Query asyncMode query={!isRevision ? GET_PAGE : GET_REVISION} variables={{ id: revisionId }}>
                {({ loading, error, data }) => {
                    if (loading) return (<div className="pageLoader"/>);
                    if (error) return <div>{error}</div>;
                    const page = data.nodeById;

                    return  (<Article {...page}/>);

                }}
            </Query>
        );
    }
}

export default ArticleRevision;



// WEBPACK FOOTER //
// ./frontend/pages/Article/ArticleRevision.jsx